import React from 'react';
import moment from 'moment';
import type { WPromotionCodeView, WDiscountView } from '@zola/svc-web-api-ts-client';
import { priceFormatter, compactCurrencyFilter } from 'components/product/PricingUtils';
import FeatureFlags from 'util/featureFlags';
import {
  ProductPriceWrapper,
  ProductStrikethroughPrice,
  OnPromotion,
  StyledLink,
} from './ProductPrice.styles';

interface ProductPriceProps {
  isCustomizable?: boolean;
  isFree?: boolean;
  isOneLine?: boolean;
  price?: number;
  promotionData?: WPromotionCodeView | null;
}

export const ProductPrice: React.FC<ProductPriceProps> = ({
  isCustomizable,
  isFree,
  isOneLine = false,
  price,
  promotionData,
}) => {
  const {
    start_time: promotionStartTime,
    end_time: promotionEndTime,
    code: promotionCode,
    discount,
  } = (promotionData as WPromotionCodeView) || {};
  const { percent_off: discountPercentOff, id: discountId } = (discount as WDiscountView) || {};
  const discountPrice = price && discountPercentOff && price - (discountPercentOff * price) / 100;
  const isStrikethroughPricingEnable = FeatureFlags.get('paperStrikethroughPricing');
  const isPromotionAvailable = moment().isBetween(
    moment(promotionStartTime),
    moment(promotionEndTime)
  );
  const isOnPromotion = isPromotionAvailable && discountPrice && promotionCode && discountId;

  if (!isStrikethroughPricingEnable || isFree || !isOnPromotion) {
    return (
      <ProductPriceWrapper>
        {isFree ? 'Free' : `${isCustomizable ? 'From ' : ''}${priceFormatter(price)} each`}
      </ProductPriceWrapper>
    );
  }

  // On promotion item with strikethrough pricing
  return (
    <ProductStrikethroughPrice isOneLine={isOneLine}>
      From {!isOneLine && <s>{priceFormatter(price)}</s>}{' '}
      <OnPromotion>
        {compactCurrencyFilter(discountPrice)} each {!isOneLine && <br />}
        {isOneLine ? 'with' : 'Use'} code{' '}
        <StyledLink color="red" noUnderline href={`/discount-terms/${discountId}`} target="_blank">
          {promotionCode.toUpperCase()} *
        </StyledLink>
      </OnPromotion>
    </ProductStrikethroughPrice>
  );
};
